import { Controller } from "@hotwired/stimulus";
import copy from 'copy-to-clipboard';

export default class extends Controller {
  static targets = ["copyValue"];

  copy(event) {
    copy(this.copyValueTarget.textContent.trim());
  }
}
